import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import ReactDOM from "react-dom";
import "./assets/css/all.min.css";
import "./assets/css/custom.css";
import "./assets/css/global.css";
import "./assets/css/responsive.css";
import "./assets/css/v5-font-face.min.css";
import MainApp from "./MainApp";
import "./public/tokens.css";
import * as serviceWorker from "./serviceWorker";
// import axios from "axios";
// import { getToken, removeUserSession } from "./utils/Auth";

import "bootstrap/dist/js/bootstrap.bundle.min";
import 'jquery-ui-dist/jquery-ui';
import 'react-lazy-load-image-component/src/effects/blur.css';

import { MathJaxContext } from "better-react-mathjax";
import { Provider } from "react-redux";
import { createStore } from "redux";
import { MainContextProvider } from "./contexts/MainContext";
import { AppQueryProvider } from "./query/AppQueryProvider";
import rootReducer from "./store/index";

const loadState = () => {
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (e) {
    return undefined;
  }
};

const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("state", serializedState);
  } catch (e) {
    // Ignore write errors;
  }
};

const peristedState = loadState();

const store = createStore(
  rootReducer,
  peristedState,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  // Others reducers...
);

store.subscribe(() => {
  saveState(store.getState());
});
// console.log = function () {};
// console.error = function () {};
// console.warn = function () {};

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppQueryProvider>
        <MainContextProvider>
          <MathJaxContext>
            <MainApp />
          </MathJaxContext>
        </MainContextProvider>
      </AppQueryProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/streamsaver/sw.js', {
      scope: '/streamsaver/'
    })
      .then(registration => {
      })
      .catch(registrationError => {
        console.log('StreamSaver SW registration failed:', registrationError);
      });
  });
}
